import apiService from "services/api";
import { openBase64InNewTab } from "utils/openBase64InNewTab";

const encodeStrippedUrlCharacters = (url) =>
	(url || "")
		.replace(/\t/g, "%09")
		.replace(/\n/g, "%0A")
		.replace(/\r/g, "%0D");

export const ProtectedImg = ({
	src = "",
	isPdf,
	isDataUri,
	noToken,
	...props
}) => {
	if (!src) return null;

	const tokenPrepend = `?token=${apiService.auth.token.get()}`;
	const encodedSrc = src?.startsWith("data")
		? src
		: encodeStrippedUrlCharacters(src);
	if (src?.endsWith(".pdf") || isPdf) {
		if (isDataUri) {
			return (
				<button
					onClick={() => openBase64InNewTab(src)}
					className="btn btn-sm btn-primary"
					target="_blank"
					rel="noreferrer"
				>
					View PDF
				</button>
			);
		}
		return (
			<a
				href={encodedSrc + (noToken ? "" : tokenPrepend)}
				className="btn my-0 btn-sm btn-primary"
				target="_blank"
				rel="noreferrer"
			>
				View PDF
			</a>
		);
	}

	return (
		<img
			alt="hello"
			src={encodedSrc + (src?.startsWith("data") ? "" : tokenPrepend)}
			{...props}
		/>
	);
};
